export const TiktokMobileThree = () => {
    return (
        <div>
            <div className="flex justify-center"><div className="text-[22px] font-bold text-[rgba(51,51,51,1)]">TIKTOK场景中常见的问题</div></div>
            <div className="flex flex-col mt-[28px] px-[20px]">
                <div className="flex ">
                    <Left content="线路不稳定，不合规，线路提供方经常跑路怎么办？" />
                    <div className="flex-1" />
                </div>
                <div className="flex mt-[12px]">
                    <div className="flex-1" />
                    <Right content="我们的底层线路源自国内三大运营商，服务器等均采用腾讯云、火山云等合规大厂服务商，并且光年无界拥有相关合规化资质，且经过备案的优质网络服务商" />
                </div>
                <div className="flex mt-[12px]">
                    <Left content="在TikTok直播的时候，遇到不进人，频繁跳红，标黄卡顿，推流不稳，断流掉线的问题怎么办？" />
                    <div className="flex-1" />
                </div>
                <div className="flex mt-[12px]">
                    <div className="flex-1" />
                    <Right content="使用自研K-WAN加速引擎，采用金融级国际专线，延迟低稳定不丢包，确保直播过程中流畅顺滑不掉线" />
                </div>
                <div className="flex mt-[12px]">
                    <Left content="在运用TK账号/养号时遇到封号、视频0播放，限流，多账号关联，起号难等问题怎么办？" />
                    <div className="flex-1" />
                </div>
                <div className="flex mt-[12px]">
                    <div className="flex-1" />
                    <Right content="我们严格挑选优质的海外头部网络运营商直采当地真实双ISP住宅IP资源，从源头上杜绝IP共用、网络污染等问题，确保你的账号安全" />
                </div>
                <div className="flex mt-[12px]">
                    <Left content="代理软件不会用，配置复杂，反复沟通调试费时间怎么办？" />
                    <div className="flex-1" />
                </div>
                <div className="flex mt-[12px]">
                    <div className="flex-1" />
                    <Right content="我们采用CPE路由器加速盒与软件/端口加速/SDK等多种接入方式，可快速交付，易维护，使用方便简单" />
                </div>
            </div>
            <div className="flex justify-center my-[40px]"><div className="text-[22px] font-bold text-[rgba(51,51,51,1)]">满足你在TikTok上的几乎任何使用需求</div></div>
            <div className="flex flex-col gap-[0px] px-[20px]">
                <div className="flex flex-col justify-center  items-center  p-[19px] bg-gradient-to-b from-blue-50 to-white rounded-[10px] border-2 border-white">
                    <div className="self-stretch justify-start text-zinc-800 text-[12px] font-bold text-center">
                        经得起三方检测的独享原生家庭IP
                    </div>
                    <div className="self-stretch justify-start text-slate-700 text-[10px] font-light font-['Alibaba_PuHuiTi_3.0'] mt-[7px]">
                        我们严格挑选优质的海外当地真实双ISP住宅IP资源，经主流IP纯净度网站检测，均为纯净家宽IP
                    </div>
                    <div className="flex mt-[10px] h-[115px] gap-[30px]">
                        <img
                            src="/imgs/tiktok/demand-1.png"
                            className="w-[176px] h-[115px]"
                        />
                        <div className="py-[10px] flex flex-col justify-between">
                            <div className="w-[70px] h-[24px]  bg-gradient-to-r from-[#64B7FF] via-[#89ABFF] to-[#B99BFF] shadow-[0_7px_14px_0_rgba(0,0,0,0.10)] rounded-[3px] shadow-[0px_7px_14px_0px_rgba(0,0,0,0.10)] inline-flex justify-center items-center gap-2.5">
                                <div className="justify-start text-white text-[12px] font-bold font-['Alibaba_PuHuiTi_3.0']">
                                    双ISP
                                </div>
                            </div>
                            <div className="w-[70px] h-[24px]  bg-gradient-to-r from-[#64B7FF] via-[#89ABFF] to-[#B99BFF] shadow-[0_7px_14px_0_rgba(0,0,0,0.10)] rounded-[3px] shadow-[0px_7px_14px_0px_rgba(0,0,0,0.10)] inline-flex justify-center items-center gap-2.5">
                                <div className="justify-start text-white text-[12px] font-bold font-['Alibaba_PuHuiTi_3.0']">
                                    值得信赖
                                </div>
                            </div>
                            <div className="w-[70px] h-[24px]  bg-gradient-to-r from-[#64B7FF] via-[#89ABFF] to-[#B99BFF] shadow-[0_7px_14px_0_rgba(0,0,0,0.10)] rounded-[3px] shadow-[0px_7px_14px_0px_rgba(0,0,0,0.10)] inline-flex justify-center items-center gap-2.5">
                                <div className="justify-start text-white text-[12px] font-bold font-['Alibaba_PuHuiTi_3.0']">
                                    纯净家宽
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex-1 p-[15px] bg-gradient-to-b from-blue-50 to-white rounded-[10px] border-2 border-white">
                    <div className="self-stretch justify-start text-zinc-800 text-[12px] font-bold text-center">
                        合规金融级国际专线，业务有保障
                    </div>
                    <div className="flex gap-[15px] justify-center items-center mt-[20px]">
                        <div>
                            <div className="self-stretch justify-start text-slate-700 text-[10px] font-medium font-['Alibaba_PuHuiTi_3.0']">
                                线路合规
                            </div>
                            <div className="mt-[6px] self-stretch justify-start text-slate-700 text-[10px] font-light font-['Alibaba_PuHuiTi_3.0']">
                                底层线路源自国内三大运营商，服务器等均采用腾讯云、火山云等合规大厂服务商，并且光年无界拥有相关合规化资质。
                            </div>
                            <div className="mt-[8px] self-stretch justify-start text-slate-700 text-[10px] font-medium font-['Alibaba_PuHuiTi_3.0']">
                                专线稳定
                            </div>
                            <div className="mt-[6px] self-stretch justify-start text-slate-700 text-[10px] font-light font-['Alibaba_PuHuiTi_3.0']">
                                使用自研K-WAN加速引擎，采用金融级国际专线，延迟低稳定不丢包
                            </div>
                            <div className="mt-[8px] self-stretch justify-start text-slate-700 text-[10px] font-medium font-['Alibaba_PuHuiTi_3.0']">
                                全球部署
                            </div>
                            <div className="mt-[6px] self-stretch justify-start text-slate-700 text-[10px] font-light font-['Alibaba_PuHuiTi_3.0']">
                                光年骨干网络节，支持美国、东南亚、欧洲、南美等TK盈盖的地区，业务拓展有保障
                            </div>
                        </div>
                        <img
                            src="/imgs/tiktok/demand-2.png"
                            className="w-[130px] h-[130px]"
                        />
                    </div>
                </div>
            </div>

            <div className="flex flex-col gap-[12px] px-[20px]">
                <div className="flex-1 flex justify-between">
                    <DemandItem
                        title="跨境直播带货"
                        description="TikTok平台开展直播带货，低成本，高安全稳定性，更流畅、真实的展现商品的功能优势特点。"
                    >
                        <img
                            src="/imgs/tiktok/item-1.png"
                            className="w-[86px] h-[127px] mt-[13px]"
                        />
                    </DemandItem>
                    <DemandItem
                        title="多场景跨境直播"
                        description="TikTok平台开展直播带货，低成本，高安全稳定性，更流畅、真实的展现商品的功能优势特点。"
                    >
                        <img
                            src="/imgs/tiktok/item-2.png"
                            className="w-[86px] h-[127px] mt-[13px]"
                        />
                    </DemandItem>
                </div>
                <div className="flex-1 flex justify-between">
                    <DemandItem
                        title="社媒短视频运营"
                        description="在TikTok平台上运营账号，通过创意视频直观展示产品的外观、细节、使用方法，使用户更容易理解产品的特点和优势，实现视频的种草与带货。"
                    >
                        <img
                            src="/imgs/tiktok/item-3.png"
                            className="w-[86px] h-[127px] mt-[13px]"
                        />
                    </DemandItem>
                    <DemandItem
                        title="支持多账号、多IP同时直播"
                        description="光年CPE路由加速盒子支持多条网线/多设备链接WIFI同时使用，每条线路均可配置不同国家/地区IP，完美支持多账号同时开播。"
                    >
                        <div className=" flex justify-center mt-[8px] w-[130px]">
                            <div className="w-full ">
                                <div className="px-[4px] py-[8px] w-full bg-white rounded-[3px] outline outline-1 outline-offset-[-1px] outline-blue-400 inline-flex justify-start items-center gap-[5px]">
                                    <div className="w-[11px] h-[11px] ">
                                        <svg viewBox="0 0 11.34 11.34" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="11.339996" height="11.339996" fill="none">
                                            <rect id="Frame" width="11.340000" height="11.340000" x="0.000000" y="0.000061" fill="rgb(255,255,255)" fillOpacity="0" />
                                            <path id="Vector" d="M-0.00312805 5.67104C-0.00312805 2.53963 2.53547 0.0010376 5.66687 0.0010376C8.79828 0.0010376 11.3369 2.53963 11.3369 5.67104C11.3369 8.80244 8.79828 11.341 5.66687 11.341C2.53547 11.341 -0.00312805 8.80244 -0.00312805 5.67104ZM4.64041 7.82642C4.71163 7.89986 4.80879 7.94247 4.91106 7.9451C5.01333 7.94773 5.11256 7.91018 5.18746 7.8405L8.90307 4.3861C8.97846 4.31536 9.02277 4.21764 9.0263 4.11432C9.02984 4.01099 8.99231 3.91048 8.92193 3.83475C8.85155 3.75902 8.75405 3.71424 8.65075 3.71021C8.54744 3.70618 8.44675 3.74322 8.37068 3.81323L4.94737 7.01972L3.34022 5.36251C3.30458 5.32515 3.2619 5.29522 3.21464 5.27444C3.16738 5.25366 3.11647 5.24245 3.06485 5.24145C3.01323 5.24044 2.96193 5.24967 2.91389 5.2686C2.86586 5.28753 2.82205 5.31578 2.78499 5.35173C2.74793 5.38768 2.71836 5.43061 2.69798 5.47804C2.6776 5.52548 2.66682 5.57648 2.66625 5.62811C2.66568 5.67973 2.67534 5.73096 2.69467 5.77883C2.71401 5.8267 2.74263 5.87027 2.77889 5.90703L4.6406 7.82642L4.64041 7.82642Z" fill="rgb(116,185,255)" fillRule="nonzero" />
                                        </svg>

                                    </div>
                                    <div className="flex-1 justify-start text-zinc-800 text-[7px] font-normal font-['Alibaba_PuHuiTi_3.0'] leading-tight">
                                        不同国家 多账号直播
                                    </div>
                                </div>
                                <div className="px-[4px] mt-[11px] w-full py-[8px] bg-white rounded-[3px] outline outline-1 outline-offset-[-1px] outline-blue-400 inline-flex justify-start items-center gap-[5px]">
                                    <div className="w-[11px] h-[11px] ">
                                        <svg viewBox="0 0 11.34 11.34" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="11.339996" height="11.339996" fill="none">
                                            <rect id="Frame" width="11.340000" height="11.340000" x="0.000000" y="0.000061" fill="rgb(255,255,255)" fillOpacity="0" />
                                            <path id="Vector" d="M-0.00312805 5.67104C-0.00312805 2.53963 2.53547 0.0010376 5.66687 0.0010376C8.79828 0.0010376 11.3369 2.53963 11.3369 5.67104C11.3369 8.80244 8.79828 11.341 5.66687 11.341C2.53547 11.341 -0.00312805 8.80244 -0.00312805 5.67104ZM4.64041 7.82642C4.71163 7.89986 4.80879 7.94247 4.91106 7.9451C5.01333 7.94773 5.11256 7.91018 5.18746 7.8405L8.90307 4.3861C8.97846 4.31536 9.02277 4.21764 9.0263 4.11432C9.02984 4.01099 8.99231 3.91048 8.92193 3.83475C8.85155 3.75902 8.75405 3.71424 8.65075 3.71021C8.54744 3.70618 8.44675 3.74322 8.37068 3.81323L4.94737 7.01972L3.34022 5.36251C3.30458 5.32515 3.2619 5.29522 3.21464 5.27444C3.16738 5.25366 3.11647 5.24245 3.06485 5.24145C3.01323 5.24044 2.96193 5.24967 2.91389 5.2686C2.86586 5.28753 2.82205 5.31578 2.78499 5.35173C2.74793 5.38768 2.71836 5.43061 2.69798 5.47804C2.6776 5.52548 2.66682 5.57648 2.66625 5.62811C2.66568 5.67973 2.67534 5.73096 2.69467 5.77883C2.71401 5.8267 2.74263 5.87027 2.77889 5.90703L4.6406 7.82642L4.64041 7.82642Z" fill="rgb(116,185,255)" fillRule="nonzero" />
                                        </svg>
                                    </div>
                                    <div className="flex-1 justify-start text-zinc-800 text-[7px] font-normal font-['Alibaba_PuHuiTi_3.0'] leading-tight">
                                        多个IP 共享单条线路带宽
                                    </div>
                                </div>
                                <div className="px-[4px] mt-[11px] w-full py-[8px] bg-white rounded-[3px] outline outline-1 outline-offset-[-1px] outline-blue-400 inline-flex justify-start items-center gap-[5px]">
                                    <div className="w-[11px] h-[11px] ">
                                        <svg viewBox="0 0 11.34 11.34" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="11.339996" height="11.339996" fill="none">
                                            <rect id="Frame" width="11.340000" height="11.340000" x="0.000000" y="0.000061" fill="rgb(255,255,255)" fillOpacity="0" />
                                            <path id="Vector" d="M-0.00312805 5.67104C-0.00312805 2.53963 2.53547 0.0010376 5.66687 0.0010376C8.79828 0.0010376 11.3369 2.53963 11.3369 5.67104C11.3369 8.80244 8.79828 11.341 5.66687 11.341C2.53547 11.341 -0.00312805 8.80244 -0.00312805 5.67104ZM4.64041 7.82642C4.71163 7.89986 4.80879 7.94247 4.91106 7.9451C5.01333 7.94773 5.11256 7.91018 5.18746 7.8405L8.90307 4.3861C8.97846 4.31536 9.02277 4.21764 9.0263 4.11432C9.02984 4.01099 8.99231 3.91048 8.92193 3.83475C8.85155 3.75902 8.75405 3.71424 8.65075 3.71021C8.54744 3.70618 8.44675 3.74322 8.37068 3.81323L4.94737 7.01972L3.34022 5.36251C3.30458 5.32515 3.2619 5.29522 3.21464 5.27444C3.16738 5.25366 3.11647 5.24245 3.06485 5.24145C3.01323 5.24044 2.96193 5.24967 2.91389 5.2686C2.86586 5.28753 2.82205 5.31578 2.78499 5.35173C2.74793 5.38768 2.71836 5.43061 2.69798 5.47804C2.6776 5.52548 2.66682 5.57648 2.66625 5.62811C2.66568 5.67973 2.67534 5.73096 2.69467 5.77883C2.71401 5.8267 2.74263 5.87027 2.77889 5.90703L4.6406 7.82642L4.64041 7.82642Z" fill="rgb(116,185,255)" fillRule="nonzero" />
                                        </svg>
                                    </div>
                                    <div className="flex-1 justify-start text-zinc-800 text-[7px] font-normal font-['Alibaba_PuHuiTi_3.0'] leading-tight">
                                        仅需一个CPE路由加速盒子即可满足最多个账号同时开
                                    </div>
                                </div>
                            </div>
                        </div>
                    </DemandItem>

                </div>
            </div>
        </div>
    )
}


const Left = (props: { content: string }) => {
    return (
        <div className="relative inline-block pl-[30px] pr-[7px] py-[5px] bg-gradient-to-br from-sky-200 via-blue-100 to-violet-100/30 rounded-[21px] shadow-[0px_4px_10px_0px_rgba(0,0,0,0.06)]">
            <div className="text-slate-700 text-[10px]  font-light font-['Alibaba_PuHuiTi_3.0']  whitespace-pre-line">
                {props.content}
            </div>
            <img
                src="/imgs/tiktok/left.png"
                className="absolute top-[-5px] left-0 w-[27px] h-[27px]"
            />
        </div>
    );
};

const Right = (props: { content: string }) => {
    return (
        <div className="relative w-fit max-w-[860px] pr-[30px] pl-[7px] inline-block py-[5px] bg-sky-200 rounded-[21px] shadow-[0px_4px_10px_0px_rgba(0,0,0,0.06)]">
            <div className="text-slate-700 text-[10px] font-normal font-['Alibaba_PuHuiTi_3.0'] whitespace-pre-line">
                {props.content}
            </div>
            <img
                src="/imgs/tiktok/right.png"
                className="absolute top-[-7px] right-0 w-[27px] h-[27px]"
            />
        </div>
    );
};
const DemandItem = (props: {
    title: string;
    description: string;
    children: React.ReactNode;
}) => {
    return (
        <div className=" p-[12px] bg-gradient-to-b from-[#F0F5FC] to-[#FFFFFF] rounded-[4px] border-[2px] border-solid [border-image:linear-gradient(180deg,rgba(255,255,255,1),rgba(240,244,252,1))_2_2]">
            <div className=" justify-start text-zinc-800 text-[12px] font-bold font-['Alibaba_PuHuiTi_3.0']">
                {props.title}
            </div>
            <div className=" justify-start text-slate-700 text-[10px] font-light font-['Alibaba_PuHuiTi_3.0'] mt-[8px]">
                {props.description}
            </div>
            <div className=" flex justify-center">{props.children}</div>
        </div>
    );
};